<template>
	<div class="index">
		<!-- 顶部导航 -->
		<van-nav-bar title="" left-text="" @click-left="toService" left-arrow fixed safe-area-inset-top>
		  <template #title>
		    <div class="site-brand">CRUSH
		    	<!-- 关键图片使用预加载 -->
		    	<img v-if="false"
					src="/img/logo.png" 
					class="van-image__img"
					alt="Site Logo"
					loading="eager"
					fetchpriority="high"
				/>
			</div>
		  </template>
		  <template #left>
		    <van-icon name="chat-o" size="26" />
		  </template>
		</van-nav-bar>

		<!-- 骨架屏 -->
		<HomeSkeleton v-if="isLoading" />

		<template v-else>
			<!-- Banner轮播 -->
			<div class="banner banners" style="margin-top: 5px;height: 10rem;" >
				<swiper class="swiper" :options="bannerSwiperOption">
				  <swiper-slide v-for="(v,key) in banners" :key="key">
						<a>
							<!-- Banner图片使用懒加载但优先加载 -->
							<img 
								:src="v.url" 
								class="banner_img"
								:alt="'Banner ' + (key + 1)"
								loading="lazy"
								:data-src="v.url"
								@load="handleImageLoad"
							/>
						</a>			      
				  </swiper-slide>
				  <!-- 空状态 -->
				  <div v-if="banners.length === 0" class="empty-banner">
					<van-empty description="No banners available" />
				  </div>
				</swiper>
			</div>

			<!-- 公告区域 -->
			<div class="announcement-section">
				<div class="announcement-header">
					<van-icon name="volume-o" />
				</div>
				<div class="announcement-content">
					<swiper class="announcement-swiper" :options="announcementSwiperOption">
					  <swiper-slide v-for="(v,key) in vip_list" :key="`announcement-${key}`">
						<span class="announcement-text">{{v}} {{$t('home.joinvip')}}</span>
					  </swiper-slide>
					  <!-- 空状态 -->
					  <div v-if="vip_list.length === 0" class="empty-announcement">
						<span class="announcement-text">{{$t('home.noAnnouncement')}}</span>
					  </div>
					</swiper>
				</div>
			</div>

			<!-- 热门公告区域 -->
			<div class="item">
				<div class="title">
					<span class="animate__animated animate__fadeIn">
						HOT
						<i style="font-size: 14px;">
							{{$t('home.gonggao')}}
						</i>
					</span>
				</div>
				<div class="girl">
					<div class="hot-announcement-container">
						<div class="hot-scroll-content">
							<div class="hot-item" v-for="(v,key) in movielist_0" :key="`hot-${key}`" @click="toPlayVideo(v.id)">
								<div class="hot-image-wrapper">
									<!-- 热门区域图片使用懒加载 -->
									<img 
										:src="v.image" 
										:data-src="v.image"
										alt="Featured announcement" 
										class="hot-image"
										loading="lazy"
										@load="handleImageLoad"
									/>
									<div class="online-badge">
										<div class="online-dot"></div>
										<span class="online-text">on line</span>
									</div>
								</div>
							</div>
							<!-- 复制一份用于无缝滚动 -->
							<div class="hot-item" v-for="(v,key) in movielist_0" :key="`hot-copy-${key}`" @click="toPlayVideo(v.id)">
								<div class="hot-image-wrapper">
									<img 
										:src="v.image" 
										:data-src="v.image"
										alt="Featured announcement" 
										class="hot-image"
										loading="lazy"
										@load="handleImageLoad"
									/>
									<div class="online-badge">
										<div class="online-dot"></div>
										<span class="online-text">on line</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 热门列表 -->
			<div class="item">
				<div class="title" style="padding-bottom: 10px;">
					<span class="animate__animated animate__fadeIn">
						{{$t('home.hotlist')}}
					</span>
				</div>
				<div class="tj">
					<ul>
						<li v-for="(v,key) in movielist_1" :key="`movie-${key}`" >
							<div class="left">
								<div class="image-wrapper">
									<!-- 用户头像使用懒加载 -->
									<img 
										:src="v.image" 
										:data-src="v.image"
										:alt="v.class_name" 
										loading="lazy"
										@load="handleImageLoad"
									/>
									<div class="profile-online-badge">
										<div class="online-dot"></div>
										<span class="online-text">on line</span>
									</div>
								</div>
								<p style="margin-top: 6px;">{{v.class_name}}</p>
							</div>
							<div class="right">
								<div class="badge-container">
									<span class="badge-item">
										<span class="van-badge__wrapper van-icon badge-icon">
											<img class="van-icon__image" src="/img/vipu.png" alt="VIP" />
										</span>
										{{$t('home.smrz')}}
									</span>
									<span class="badge-item">
										<span class="van-badge__wrapper van-icon badge-icon">
											<img class="van-icon__image" src="/img/vipu.png" alt="VIP" />
										</span>
										{{$t('home.videorz')}}
									</span>
								</div>
								<div class="tags-container">
									<span v-for="(val,index) in v.tags_arr" :key="index" class="tag">{{val}}</span>
								</div>
								<div class="info-container">
									<p class="star-rating">
										{{$t('home.star')}}:
										<span v-for="(numa,indexs) in v.star" :key="indexs" class="star"></span>
									</p>
									<div class="user-details">
										{{$t('home.sg')}}: {{formatHeight(v.sg)}} {{$t('home.xw')}}: {{v.sw}}
									</div>
								</div>
								<div class="apply-btn" @click="profile(v.id)">
									{{$t('home.apply')}}
								</div>
							</div>
						</li>
					</ul>
					<van-empty v-if="movielist_1.length === 0" description="No recommendations available" />
				</div>
			</div>
		</template>

		<div v-if="popupVisible" class="home-popup-layer" role="dialog" aria-modal="true">
			<div class="home-notice-dialog" style="display:flex !important; visibility:visible !important; opacity:1 !important;">
				<div class="home-popup-head">
					<van-icon name="volume-o" />
					<span>{{ popupNotice.name || $t('systemNotice') }}</span>
				</div>
				<div class="home-popup-content" v-html="popupNotice.text"></div>
				<button type="button" class="home-popup-confirm" @click="closeHomePopup">
					{{ $t('game.confirm') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import cacheManager from '../../common/cache';
import { formatHeightFromCm } from '../../common/height';

// 懒加载组件
const HomeSkeleton = () => import('./components/HomeSkeleton.vue');

export default {
  name: 'HomeIndex',
  components: {
    HomeSkeleton
  },
  data() {
    return {
      notice: "",
      banners: [],
      basicData: [],
      gameitem: [],
      movielist_0: [],
      movielist_1: [],
      vip_list: [],
      popupVisible: false,
      popupNotice: {},
      popupTimer: null,
      isLoading: true,
      isError: false,
      errorMessage: '',
      // 图片加载状态
      loadedImages: new Set(),
      movielistSwiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
      bannerSwiperOption: {
        loop: false,
        speed: 1000,
        autoplay: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1
        }
      },
      vipSwiperOption: {
        direction: 'vertical',
        slidesPerView: 7,
        loop: true,
        speed: 1000,
        autoplay: true
      },
      announcementSwiperOption: {
        direction: 'vertical',
        slidesPerView: 1,
        loop: true,
        speed: 800,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        spaceBetween: 0
      }
    };
  },
  methods: {
    hasKnownValue(value) {
      const normalized = String(value == null ? '' : value).trim().toLowerCase();
      return Boolean(normalized) && ![
        '未知', 'unknown', 'n/a', 'na', 'null', 'undefined', '-', '--'
      ].includes(normalized);
    },
    formatHeight(value) {
      return formatHeightFromCm(value);
    },
    /**
     * 高性能图片加载处理
     */
    handleImageLoad(event) {
      const img = event.target;
      const src = img.getAttribute('data-src') || img.src;
      
      // 标记图片已加载
      this.loadedImages.add(src);
      
      // 移除加载中的样式（如果有）
      img.classList.remove('image-loading');
      img.classList.add('image-loaded');
    },

    handleGlobalImageError(event) {
      const img = event.target;
      if (!img || img.tagName !== 'IMG') return;

      if (img.dataset.cacheRetry !== '1') {
        img.dataset.cacheRetry = '1';
        const source = img.currentSrc || img.src;
        try {
          const url = new URL(source, window.location.href);
          url.searchParams.set('_retry', Date.now());
          event.stopImmediatePropagation();
          img.src = url.toString();
          return;
        } catch (error) {
          // Keep the original source when it cannot be parsed.
        }
      }

      console.warn('图片加载失败:', img.src);
    },

    /**
     * 预加载关键图片
     */
    preloadCriticalImages() {
      // 预加载Logo和关键图标
      const criticalImages = [
        '/img/logo.png',
        '/img/vipu.png'
      ];
      
      criticalImages.forEach(src => {
        const img = new Image();
        img.src = src;
      });
    },

    /**
     * 初始化图片懒加载观察器
     */
    initImageLazyLoad() {
      if ('IntersectionObserver' in window) {
        // 修复：移除未使用的 observer 参数
        const imageObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              const dataSrc = img.getAttribute('data-src');
              
              if (dataSrc && !this.loadedImages.has(dataSrc)) {
                img.src = dataSrc;
                img.removeAttribute('data-src');
              }
              
              imageObserver.unobserve(img);
            }
          });
        });

        // 下一帧开始观察图片
        this.$nextTick(() => {
          document.querySelectorAll('img[data-src]').forEach(img => {
            imageObserver.observe(img);
          });
        });
      } else {
        // 浏览器不支持 IntersectionObserver 的回退方案
        this.fallbackImageLoad();
      }
    },

    /**
     * 回退图片加载方案
     */
    fallbackImageLoad() {
      // 简单的回退：直接加载所有图片
      this.$nextTick(() => {
        document.querySelectorAll('img[data-src]').forEach(img => {
          const dataSrc = img.getAttribute('data-src');
          if (dataSrc && !this.loadedImages.has(dataSrc)) {
            img.src = dataSrc;
            img.removeAttribute('data-src');
          }
        });
      });
    },

    gotoMenu(router) {
      this.$router.replace(router)
    },
    
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
      } else {
        this.$router.push({ path: '/Lottery?key=' + key + "&id=" + id })
      }
    },

    profile(id) {
      this.$router.push({ path: '/profile?id=' + id });
    },

    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("ServiceOnline");
      } else {
        this.$toast(this.$t('common.refresh'));
      }
    },

    toPlayVideo(id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
      } else {
        this.$router.push({ path: '/PlayVideo?id=' + id })
      }
    },

    async onRefresh() {
      this.isLoading = true;
      this.loadedImages.clear();
      try {
        await this.getBasicConfig();
        this.showHomePopupAfterRender();
        this.$toast(this.$t('common.refreshSuccess'));
      } catch (error) {
        this.$toast(this.$t('common.refreshFailed'));
      } finally {
        this.isLoading = false;
      }
    },

    async getBasicConfig() {
      try {
        // 首页开关与欢迎语始终读取后台最新配置。
        const response = await this.$http({
          method: 'get',
          url: 'sys_config'
        });
        
        this.processBasicData(response.data);
        
      } catch (error) {
        console.error('获取基本配置失败:', error);
        this.isError = true;
        this.errorMessage = 'Loading failed. Please try again.';
        this.$toast(this.$t('common.loadFailed'));
      }
    },

    processBasicData(data) {
      this.basicData = data;
      this.vip_list = Array.isArray(data.vip_list) && data.vip_list.length
        ? data.vip_list
        : (data.notice ? [data.notice] : []);
      this.getNotice(data);
      this.prepareHomePopup(data.base || data);
      this.getBanner(data);
      this.getGameItem();
      this.getMovieList_0(data);
      this.getMovieList_1();
      this.getXuanfeiRecommendations();
    },

    getNotice(data) {
      this.notice = data.notice || this.$t('home.noNotice');
    },

    prepareHomePopup(config) {
      if (!config || !config.welcome_content) return;
      const popupEnabled = typeof config.welcome_popup_enabled === 'undefined'
        ? true
        : Number(config.welcome_popup_enabled) === 1;
      if (!popupEnabled) {
        this.popupNotice = {};
        this.popupVisible = false;
        return;
      }
      this.popupNotice = {
        name: config.welcome_title || this.$t('systemNotice'),
        text: config.welcome_content
      };
    },

    showHomePopupAfterRender() {
      if (!this.popupNotice.text) return;
      clearTimeout(this.popupTimer);
      this.popupTimer = setTimeout(() => {
        this.popupVisible = true;
      }, 300);
    },

    closeHomePopup() {
      this.popupVisible = false;
    },

    async getGameItem() {
      const cacheKey = 'lottery_home_entry_v2';
      
      try {
        // 先尝试从缓存获取
        const cachedData = cacheManager.get(cacheKey);
        if (cachedData) {
          console.log('使用缓存的游戏列表');
          this.gameitem = cachedData;
          return;
        }
        
        // 缓存中没有，从API获取
        let response = await this.$http({
          method: 'get',
          url: 'lottery_hot'
        });

        // Keep the home task entrance available when no task is marked hot.
        if (!Array.isArray(response.data) || response.data.length === 0) {
          response = await this.$http({
            method: 'get',
            url: 'lottery_list'
          });
        }
        
        this.gameitem = Array.isArray(response.data) ? response.data : [];
        
        // 缓存游戏列表（1分钟）
        cacheManager.set(cacheKey, this.gameitem, 60 * 1000);
        
      } catch (error) {
        console.error('获取游戏列表失败:', error);
        this.gameitem = [];
      }
    },

    getMovieList_0(data) {
      this.movielist_0 = (data.movielist_0 || []).map(item => ({
        ...item,
        image: item.image || item.cover || item.vod_pic,
        title: item.title || item.vod_name
      }));
    },

    getMovieList_1() {
      this.movielist_1 = [];
    },

    async getXuanfeiRecommendations() {
      try {
        const response = await this.$http({
          method: 'get',
          url: 'xuanfeilist',
          data: { id: 'all', page: 1, limit: 10 }
        });
        const list = Array.isArray(response.data) ? response.data : [];
        this.movielist_1 = list.map(item => {
          const localizedFlag = String(item.flag || '').split('|')[0] || '';
          return {
            ...item,
            image: item.image || item.img_url,
            sg: formatHeightFromCm(item.sg || item.hight || item.height || ''),
            sw: item.sw || item.bust || '',
            class_name: item.class_name || item.address || '',
            star: Number(item.star || item.number || 0),
            tags_arr: Array.isArray(item.tags_arr)
              ? item.tags_arr
              : localizedFlag.split(/[，,]/).filter(Boolean)
          };
        });
      } catch (error) {
        console.error('Failed to load recommendations:', error);
        this.movielist_1 = [];
      }
    },

    getBanner(data) {
      this.banners = data.banners || [];
    }
  },
  mounted() {
    // 初始化图片懒加载
    this.initImageLazyLoad();
    
    // 添加全局错误监听（轻量级）
    window.addEventListener('error', this.handleGlobalImageError, true);
  },
  async created() {
    // 预加载关键图片
    this.preloadCriticalImages();
    
    // 使用Promise.all并行加载数据
    await Promise.all([
      this.getBasicConfig()
    ]);
    this.isLoading = false;
    this.$nextTick(() => this.showHomePopupAfterRender());
    
    // 数据加载完成后初始化懒加载
    this.$nextTick(() => {
      this.initImageLazyLoad();
    });
  },
  beforeDestroy() {
    clearTimeout(this.popupTimer);
    // 清理事件监听
    window.removeEventListener('error', this.handleGlobalImageError, true);
  }
}
</script>

<style lang='less' scoped>
@import "../../assets/css/basenew.css";

/* 移动端样式 - 强制所有屏幕都使用移动端样式 */
.index {
    width: 100%;
    min-height: 100vh;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    position: relative;
    margin: 0 auto;
}

/* 强制所有屏幕都使用移动端布局 */
body {
    margin: 0;
    padding: 0;
    background: #f0f0f0;
    display: block;
}

/* 移除所有桌面端样式，只保留移动端样式 */

/* 图片加载优化样式 */
.image-loading {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

.image-loaded {
  opacity: 1;
  transition: opacity 0.3s ease;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* 为图片添加加载状态 */
.hot-image,
.game-image,
.banner_img,
.image-wrapper img {
  opacity: 0;
  transition: opacity 0.3s ease;
}

.hot-image.image-loaded,
.game-image.image-loaded,
.banner_img.image-loaded,
.image-wrapper img.image-loaded {
  opacity: 1;
}

/* 新增：公告区域样式 */
/* 修改公告区域样式 - 透明背景无边框 */
.announcement-section {
    display: flex;
    align-items: flex-start;
    background: rgba(255, 255, 255, 0.1) !important; /* 透明背景 */
    margin: 12px 15px;
    border-radius: 12px;
    padding: 12px 16px;
    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); 
    border: 1px solid rgba(0, 0, 0, 0.1); */
    position: relative;
    overflow: hidden;
    backdrop-filter: blur(10px); /* 毛玻璃效果 */
    -webkit-backdrop-filter: blur(10px);
}

.announcement-section::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(0,0,0,0.2), transparent);
}

.announcement-header {
    display: flex;
    align-items: flex-start;
    min-width: 60px;
    margin-right: 12px;
}

.announcement-header .van-icon {
    color: #000 !important; /* 黑色图标 */
    margin-right: 6px;
    filter: none;
}

.announcement-title {
    color: #000 !important; /* 黑色标题 */
    font-size: 18px;
    font-weight: 600;
    white-space: nowrap;
    text-shadow: none;
}

.announcement-content {
    flex: 1;
    height: 24px;
    overflow: hidden;
    position: relative;
}

.announcement-swiper {
    height: 100%;
}

.announcement-swiper .swiper-slide {
    display: flex;
    align-items: center;
    height: 24px;
}

.announcement-text {
    color: #000 !important; /* 黑色文字 */
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-shadow: none;
    opacity: 0.9;
}

.empty-announcement {
    display: flex;
    align-items: center;
    height: 100%;
}

/* 最简单的解决方案 */
.van-nav-bar {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%) !important;
    height: auto;
    min-height: 46px;
    padding-top: env(safe-area-inset-top);
    padding-bottom: 0;
}

/* 关键：增加更多顶部间距 */
.index {
    padding-top: calc(66px + env(safe-area-inset-top) + 20px); /* 增加到20px */
}

.banner.banners {
    margin-top: 0;
    /* 确保轮播图不会被任何元素遮挡 */
    position: relative;
}

.page-loading {
    display: flex;
    justify-content: center;
    padding: 40px 0;
}

.empty-banner,
.empty-vip {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #999;
    font-size: 14px;
}

/* 热门公告区域新样式 - 纯图片版本 */
.hot-announcement-container {
    width: 100%;
    overflow: hidden;
    position: relative;
    margin-bottom: 0;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
    border-radius: 12px;
    padding: 12px 0;
}

.hot-scroll-content {
    display: flex;
    animation: hotScroll 500s linear infinite;
    width: max-content;
}

.hot-scroll-content:hover {
    animation-play-state: paused;
}

.hot-item {
    flex-shrink: 0;
    width: 220px;
    height: 260px;
    margin: 0 8px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    background: white;
}

.hot-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0,0,0,0.25);
}

.hot-image-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.hot-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.hot-item:hover .hot-image {
    transform: scale(1.1);
}

/* 绿色在线徽章样式 - 热门公告区域 */
.online-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.95);
    padding: 4px 8px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
    animation: onlinePulse 2s infinite;
    backdrop-filter: blur(5px);
    border: 1px solid rgba(34, 197, 94, 0.2);
    z-index: 1000;
}

.online-dot {
    width: 8px;
    height: 8px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    border-radius: 50%;
    margin-right: 4px;
    animation: dotPulse 1.5s infinite;
    box-shadow: 0 0 6px rgba(34, 197, 94, 0.6);
}

.online-text {
    font-size: 11px;
    font-weight: 600;
    color: #15803d;
    white-space: nowrap;
}

@keyframes onlinePulse {
    0% {
        box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
    }
    50% {
        box-shadow: 0 2px 12px rgba(34, 197, 94, 0.5);
    }
    100% {
        box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
    }
}

@keyframes dotPulse {
    0% {
        box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.7);
    }
    70% {
        box-shadow: 0 0 0 4px rgba(34, 197, 94, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
    }
}

@keyframes hotScroll {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}

/* 热门推荐列表图片容器 */
.image-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
}

/* 绿色在线徽章样式 - 热门推荐列表 */
.profile-online-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.95);
    padding: 4px 8px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
    animation: onlinePulse 2s infinite;
    backdrop-filter: blur(5px);
    border: 1px solid rgba(34, 197, 94, 0.2);
    z-index: 1000;
}

.profile-online-badge .online-dot {
    width: 8px;
    height: 8px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    border-radius: 50%;
    margin-right: 4px;
    animation: dotPulse 1.5s infinite;
    box-shadow: 0 0 6px rgba(34, 197, 94, 0.6);
}

.profile-online-badge .online-text {
    font-size: 11px;
    font-weight: 600;
    color: #15803d;
    white-space: nowrap;
}

/* 强制移除所有 #ebcaaf 颜色的遮挡元素 */
.left [style*="background-color: #ebcaaf"],
.left [style*="background:#ebcaaf"],
.left [style*="background: #ebcaaf"],
.left [style*="background-color:#ebcaaf"],
.left [style*="#ebcaaf"] {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    width: 0 !important;
    height: 0 !important;
    overflow: hidden !important;
}

/* 移除所有可能包含 #ebcaaf 颜色的span和i元素 */
.left > span,
.left span[style*="position"],
.left i[style*="position"],
.left span[style*="absolute"],
.left i[style*="absolute"] {
    display: none !important;
}

/* 移除所有绝对定位的可能遮挡元素 */
.left [style*="position: absolute"],
.left [style*="position:absolute"],
.left [style*="absolute"] {
    display: none !important;
}

/* 移除所有右上角的元素 */
.left [style*="top"],
.left [style*="right"] {
    background: transparent !important;
}

/* 确保图片显示正常 */
.image-wrapper img {
    display: block;
    width: 100%;
    border-radius: 8px;
    position: relative;
    z-index: 1;
}

/* 最强制的方法：隐藏所有不是图片和在线徽章的元素 */
.left > *:not(.image-wrapper):not(.profile-online-badge) {
    background-color: transparent !important;
}

/* 检查所有直接子元素 */
.left > span,
.left > i,
.left > div:not(.image-wrapper) {
    display: none !important;
}

/* 确保在线徽章在最前面 */
.profile-online-badge {
    z-index: 9999 !important;
}

/* 如果有伪元素遮挡 */
.left::before,
.left::after,
.image-wrapper::before,
.image-wrapper::after {
    display: none !important;
    content: none !important;
}

/* 热门游戏列表样式 */
.game-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    padding: 0 10px;
    margin-top: 10px;
}

.game-list li {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

.game-list li:hover {
    transform: translateY(-5px);
}

.game-image-container {
    width: 100%;
    aspect-ratio: 1/1;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    border: 2px solid rgba(255,255,255,0.1);
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
    transition: all 0.3s ease;
    position: relative;
}

.game-list li:hover .game-image-container {
    box-shadow: 0 6px 20px rgba(0,0,0,0.25);
    border-color: rgba(255,255,255,0.3);
    transform: scale(1.05);
}

.game-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
    transition: transform 0.3s ease;
}

.game-list li:hover .game-image {
    transform: scale(1.1);
}

.game-name {
    margin-top: 8px;
    font-size: 12px;
    color: #333;
    text-align: center;
    font-weight: 500;
    line-height: 1.2;
    transition: color 0.3s ease;
}

.game-list li:hover .game-name {
    color: #667eea;
}

/* 热门列表右侧文字样式优化 */
.tj {
  ul {
    padding: 0 12px;
    
    li {
      display: flex;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-radius: 16px;
      margin-bottom: 16px;
      padding: 16px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      border: 1px solid rgba(255, 255, 255, 0.8);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 25px rgba(0, 0, 0, 0.12);
      }
      
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: linear-gradient(90deg, #3498db, #8e44ad, #f093fb);
        border-radius: 16px 16px 0 0;
      }
    }
  }
}

/* 左侧内容区域调整 */
.left {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
}

/* 右侧内容区域美化 */
.right {
  flex: 1;
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  .badge-container {
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
    
    .badge-item {
      display: flex;
      align-items: center;
      font-size: 20px;
      color: #4a5568;
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
      padding: 6px 12px;
      border-radius: 20px;
      border: 1px solid rgba(102, 126, 234, 0.2);
      font-weight: 500;
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
      }
      
      .badge-icon {
        margin-right: 6px;
        
        .van-icon__image {
          width: 14px;
          height: 14px;
          filter: drop-shadow(0 1px 2px rgba(0,0,0,0.1));
        }
      }
    }
  }
  
  .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 12px;
    
    .tag {
      background: linear-gradient(135deg, #a8edea, #fed6e3);
      color: #2d3748;
      padding: 4px 10px;
      border-radius: 12px;
      font-size: 18px;
      font-weight: 600;
      border: 1px solid rgba(255, 255, 255, 0.6);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
      }
    }
  }
  
  .info-container {
    background: rgba(248, 250, 252, 0.8);
    padding: 12px;
    border-radius: 12px;
    margin-bottom: 12px;
    border: 1px solid rgba(226, 232, 240, 0.6);
    backdrop-filter: blur(10px);
    
    .star-rating {
      color: #e53e3e;
      font-weight: 700;
      margin-bottom: 6px;
      font-size: 20px;
      display: flex;
      align-items: center;
      
      .star {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="%23f6ad55" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>') no-repeat;
        margin: 0 2px;
        filter: drop-shadow(0 1px 1px rgba(0,0,0,0.2));
      }
    }
    
    .user-details {
      color: #718096;
      font-size: 22px;
      line-height: 1.5;
      font-weight: 500;
      background: linear-gradient(135deg, #4a5568, #718096);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  
  .apply-btn {
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
    color: white;
    padding: 12px 24px;
    border-radius: 25px;
    text-align: center;
    font-weight: 700;
    font-size: 22px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
    position: relative;
    overflow: hidden;
    letter-spacing: 0.5px;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
      transition: left 0.6s;
    }
    
    &:hover::before {
      left: 100%;
    }
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 10px rgba(102, 126, 234, 0.4);
    }
  }
}

/* 空状态美化 */
.van-empty {
  padding: 40px 20px;
  
  .van-empty__image {
    width: 80px;
    height: 80px;
  }
  
  .van-empty__description {
    color: #a0aec0;
    font-size: 14px;
    margin-top: 12px;
  }
}

/* 响应式优化 - 只保留小屏幕优化 */
@media (max-width: 375px) {
    .banner.banners {
        height: 8rem;
    }
    
    .game-list {
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
    }
    
    .hot-item {
        width: 120px;
        height: 160px;
        margin: 0 6px;
    }
    
    .online-badge {
        padding: 3px 6px;
        border-radius: 10px;
    }
    
    .online-text {
        font-size: 10px;
    }
    
    .online-dot {
        width: 6px;
        height: 6px;
    }
    
    .profile-online-badge {
        padding: 3px 6px;
        border-radius: 10px;
    }
    
    .profile-online-badge .online-text {
        font-size: 10px;
    }
    
    .tj ul li {
        padding: 12px;
        margin-bottom: 12px;
    }
    
    .right {
        margin-left: 12px;
        
        .badge-container {
            gap: 8px;
            
            .badge-item {
                font-size: 11px;
                padding: 4px 10px;
            }
        }
        
        .apply-btn {
            padding: 10px 20px;
            font-size: 13px;
        }
    }
    
    /* 公告区域响应式 */
    .announcement-section {
        margin: 10px 12px;
        padding: 10px 12px;
    }
    
    .announcement-header {
        min-width: 50px;
        margin-right: 10px;
    }
    
    .announcement-title {
        font-size: 13px;
    }
    
    .announcement-text {
        font-size: 12px;
    }
}

@media (max-width: 320px) {
    .game-list {
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
    }
    
    .hot-item {
        width: 120px;
        height: 160px;
        margin: 0 5px;
    }
    
    .online-badge {
        padding: 2px 4px;
    }
    
    .online-text {
        font-size: 9px;
    }
    
    .profile-online-badge {
        padding: 2px 4px;
    }
    
    .profile-online-badge .online-text {
        font-size: 9px;
    }
    
    /* 公告区域响应式 */
    .announcement-section {
        margin: 8px 10px;
        padding: 8px 10px;
    }
    
    .announcement-header {
        min-width: 45px;
    }
    
    .announcement-title {
        font-size: 12px;
    }
    
    .announcement-text {
        font-size: 11px;
    }
}

/* 优化图片样式 */
.van-image__img,
.banner_img {
    object-fit: cover;
}

/* 无障碍访问支持 */
@media (prefers-reduced-motion: reduce) {
    .hot-scroll-content {
        animation: none;
    }
    
    .hot-item:hover,
    .game-list li:hover,
    .tj ul li:hover {
        transform: none;
    }
    
    .apply-btn::before {
        display: none;
    }
    
    .online-badge,
    .profile-online-badge {
        animation: none;
    }
    
    .online-dot {
        animation: none;
    }
    
    .announcement-swiper {
        .swiper-wrapper {
            transition-duration: 0ms !important;
        }
    }
}

/* 动画性能优化 */
.hot-scroll-content {
    will-change: transform;
}

.hot-item {
    transform: translateZ(0);
}

/* 性能优化：减少重绘和回流 */
.index {
    contain: layout style paint;
}

.item {
    contain: layout;
}

/* 滚动性能优化 */
.hot-announcement-container {
    transform: translateZ(0);
}

/* 图片加载优化 */
.van-image__img,
.banner_img,
.hot-image,
.game-image {
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
}

/* Midnight Gold — aligned with the login experience */
.index {
    min-height: 100vh;
    padding-bottom: 74px;
    color: #f5ead5;
    background:
        linear-gradient(180deg, rgba(2, 5, 9, 0.18), rgba(2, 5, 9, 0.94) 42%, #05070a 100%),
        url('../../assets/img/luxury-dating-bg-v2.png') center top / cover fixed no-repeat;
}

.van-nav-bar {
    background: linear-gradient(90deg, rgba(5, 8, 13, 0.98), rgba(22, 17, 10, 0.96)) !important;
    border-bottom: 1px solid rgba(218, 180, 105, 0.38);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.38);
}

.van-nav-bar .van-icon {
    color: #e4c47f !important;
}

.banner.banners {
    margin: 58px 14px 12px !important;
    border: 1px solid rgba(226, 190, 116, 0.4);
    border-radius: 24px;
    overflow: hidden;
    background: rgba(8, 11, 16, 0.76);
    box-shadow: 0 20px 52px rgba(0, 0, 0, 0.52);
}

.announcement-section,
.item {
    margin: 14px;
    padding: 16px;
    border: 1px solid rgba(218, 180, 105, 0.25);
    border-radius: 24px;
    background: linear-gradient(145deg, rgba(8, 11, 17, 0.86), rgba(17, 17, 19, 0.7));
    backdrop-filter: blur(13px) saturate(120%);
    box-shadow: 0 18px 44px rgba(0, 0, 0, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.announcement-title,
.announcement-text,
.item > .title,
.item > .title span {
    color: #ead09a;
}

.item > .title {
    margin-bottom: 12px;
    font-family: Georgia, 'Noto Serif SC', serif;
    letter-spacing: 1px;
}

.item > .title i {
    padding: 7px 13px;
    border: 1px solid rgba(224, 187, 111, 0.38);
    border-radius: 999px;
    color: #e9cb8f;
    background: rgba(205, 158, 79, 0.12);
}

.hot-item,
.game-list li,
.tj ul li {
    border: 1px solid rgba(224, 187, 111, 0.28);
    border-radius: 18px;
    background: rgba(9, 12, 17, 0.88);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.34);
    overflow: hidden;
}

.game-name,
.tj ul li,
.tj .user-details,
.tj .star-rating {
    color: #eee4d2;
}

.badge-item,
.tag {
    border-color: rgba(219, 178, 101, 0.38) !important;
    color: #dfbd78 !important;
    background: rgba(213, 170, 91, 0.1) !important;
}

.apply-btn {
    border: 1px solid rgba(247, 220, 160, 0.48);
    border-radius: 16px;
    color: #171109;
    background: linear-gradient(115deg, #9b6b2f, #e5c47c 50%, #b88743);
    box-shadow: 0 10px 28px rgba(190, 141, 62, 0.26);
}

/* Readable typography on the dark luxury surface */
.index,
.index p,
.index h1,
.index h2,
.index h3,
.index .title,
.index .game-name,
.index .user-details,
.index .star-rating,
.index .announcement-text,
.index .empty-announcement,
.index .tj ul li {
    color: #f3eadb !important;
}

.index .item > .title,
.index .item > .title span,
.index .announcement-title,
.index .username,
.index .class-name {
    color: #e4c27e !important;
}

.index .profile-info,
.index .time-text,
.index .secondary-text {
    color: rgba(241, 232, 215, 0.72) !important;
}

.index .announcement-section {
    min-height: 58px;
    padding: 13px 16px;
}

.index .announcement-header {
    min-width: 34px;
    width: 34px;
    flex: 0 0 34px;
    margin-right: 8px;
    align-items: center;
    justify-content: center;
    gap: 0;
}

.index .announcement-title {
    font-size: 1.2rem !important;
    font-weight: 700;
    white-space: nowrap;
}

.index .announcement-header .van-icon {
    font-size: 30px !important;
    width: 32px;
    min-width: 32px;
    color: #e5c47c !important;
    flex: 0 0 32px;
    margin-right: 0 !important;
    opacity: 1 !important;
    text-shadow: 0 0 10px rgba(229, 196, 124, 0.35);
}

.index .announcement-header .van-icon::before {
    color: #e5c47c !important;
}

.index .announcement-text {
    display: block;
    width: max-content;
    min-width: 100%;
    font-size: 15px !important;
    line-height: 1.65;
    letter-spacing: 0.2px;
    white-space: nowrap;
    animation: announcementMarquee 18s linear infinite;
    will-change: transform;
}

.index .announcement-content,
.index .announcement-swiper,
.index .announcement-swiper .swiper-slide {
    overflow: hidden;
}

.index .announcement-section:hover .announcement-text {
    animation-play-state: paused;
}

@keyframes announcementMarquee {
    0% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(-100%);
    }
}

.index .apply-btn,
.index .apply-btn span {
    color: #171109 !important;
}

.index .tj .info-container {
    margin: 8px 0 10px;
    padding: 12px 14px;
    border: 1px solid rgba(218, 180, 105, 0.28) !important;
    border-radius: 15px;
    background: linear-gradient(145deg, rgba(18, 21, 27, 0.94), rgba(7, 10, 15, 0.9)) !important;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 8px 20px rgba(0, 0, 0, 0.22);
    backdrop-filter: blur(10px);
}

.index .tj .info-container .star-rating {
    margin-bottom: 7px;
    color: #e4c27e !important;
    -webkit-text-fill-color: #e4c27e !important;
    font-size: 16px !important;
}

.index .tj .info-container .user-details {
    color: rgba(243, 234, 219, 0.82) !important;
    -webkit-text-fill-color: rgba(243, 234, 219, 0.82) !important;
    background: none !important;
    font-size: 12px !important;
    line-height: 1.5;
}

.index .tj .right .apply-btn {
    width: 100%;
    min-height: 40px;
    padding: 8px 14px;
    border: 1px solid rgba(247, 220, 160, 0.56) !important;
    border-radius: 15px !important;
    color: #171109 !important;
    background: linear-gradient(115deg, #9b6b2f 0%, #e7c77f 50%, #b88743 100%) !important;
    box-shadow: 0 9px 24px rgba(190, 141, 62, 0.3) !important;
    font-size: 17px !important;
    font-weight: 700;
    letter-spacing: 1px;
}

.index .tj .badge-item,
.index .tj .tag {
    padding: 4px 8px !important;
    font-size: 13px !important;
    line-height: 1.2;
}

.index .tj .left p {
    font-size: 15px !important;
    line-height: 1.4;
}

@media (max-width: 480px) {
    .announcement-section,
    .item {
        margin: 12px;
        padding: 14px;
        border-radius: 20px;
    }

    .banner.banners {
        margin-left: 12px !important;
        margin-right: 12px !important;
        border-radius: 20px;
    }

    .index .announcement-section {
        padding: 12px 14px;
    }

    .index .announcement-title {
        font-size: 16px !important;
    }

    .index .announcement-text {
        font-size: 14px !important;
    }
}

.site-brand {
    color: #ffffff;
    font-family: 'Arial Black', 'Trebuchet MS', Arial, sans-serif;
    font-size: 2.35rem;
    line-height: 1;
    font-style: italic;
    font-weight: 900;
    letter-spacing: -.055em;
    white-space: nowrap;
    transform: skewX(-3deg);
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke: 1.5px #f2ca6b;
    text-shadow:
      1px 1px 0 #c79435,
      2px 2px 0 #8d6222,
      3px 3px 0 #213d52,
      4px 4px 0 #142637,
      5px 5px 0 #08131e;
}

/* 人气推荐卡片：使用 rem 避免字体被 viewport 插件二次缩小 */
.index .tj .badge-item,
.index .tj .tag {
    padding: .38rem .62rem !important;
    font-size: .92rem !important;
    line-height: 1.25 !important;
    border-radius: .7rem !important;
}

.index .tj .info-container .star-rating {
    margin-bottom: .45rem;
    font-size: 1.08rem !important;
    line-height: 1.35 !important;
}

.index .tj .info-container .star-rating .star {
    width: 1rem;
    height: 1rem;
    margin: 0 .1rem;
}

.index .tj .info-container .user-details {
    font-size: .9rem !important;
    line-height: 1.55 !important;
}

.index .tj .right .apply-btn {
    min-height: 2.8rem;
    padding: .7rem .9rem;
    font-size: 1.05rem !important;
    line-height: 1.35;
}

.index .tj .left p {
    font-size: .95rem !important;
}

/* 首页品牌栏：按品牌展示图提高顶部比例 */
.home-popup-layer {
    position: fixed;
    inset: 0;
    z-index: 30000;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 0 1.25rem;
    background: rgba(0, 0, 0, .62);
    backdrop-filter: none !important;
}

.home-notice-dialog {
    position: relative !important;
    left: auto !important;
    top: auto !important;
    z-index: 30002 !important;
    width: 82vw;
    max-width: 22rem;
    max-height: 56vh;
    display: flex !important;
    flex-direction: column;
    visibility: visible !important;
    opacity: 1 !important;
    transform: none !important;
    margin-top: 250PX;
    animation: none !important;
    transition: none !important;
    overflow: hidden;
    border: 1px solid rgba(230, 194, 119, .65);
    border-radius: 22px;
    background: linear-gradient(150deg, #16130e, #070a0e 48%, #11100d);
    box-shadow: 0 24px 70px rgba(0, 0, 0, .78);
}

.home-popup-head {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .55rem;
    padding: 1.25rem 1.2rem .8rem;
    color: #edcd83;
    font-size: 1.12rem;
    font-weight: 760;
    letter-spacing: .04em;
}

.home-popup-head .van-icon { font-size: 1.3rem; }

.home-popup-content {
    max-height: 32vh;
    padding: .55rem 1.2rem 1.1rem;
    overflow-y: auto;
    color: #ddd1bd;
    font-size: .94rem;
    line-height: 1.75;
    text-align: left;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

.home-popup-confirm {
    flex: 0 0 auto;
    width: 100%;
    height: 3.2rem;
    border: 0;
    border-top: 1px solid rgba(220, 181, 101, .22);
    color: #1a1207;
    font-size: .95rem;
    font-weight: 750;
    background: linear-gradient(100deg, #b98236, #edcf82, #bd8739);
}

.index ::v-deep .van-nav-bar {
    min-height: 5rem;
    height: calc(5rem + env(safe-area-inset-top));
    padding-top: env(safe-area-inset-top);
    background: linear-gradient(90deg, #030609, #151007, #030609) !important;
}

.index ::v-deep .van-nav-bar__content {
    height: 5rem;
}

.index ::v-deep .van-nav-bar__title {
    width: calc(100% - 8rem);
    max-width: none;
    padding: 0 .65rem .35rem 0;
    overflow: visible;
    box-sizing: border-box;
}

.index ::v-deep .van-nav-bar__left {
    height: 5rem;
    padding: 0 18px;
}

.index ::v-deep .van-nav-bar__left .van-icon {
    font-size: 28px !important;
}

.index {
    padding-top: calc(5rem + env(safe-area-inset-top)) !important;
}

.banner.banners {
    margin-top: 14px !important;
}

/* 320-430px 精细适配：避免卡片、长翻译与底部导航互相遮挡 */
@media (max-width: 430px) {
    .index {
        width: 100%;
        max-width: 100vw;
        min-height: 100dvh;
        padding-top: calc(clamp(3rem, 14vw, 3.5rem) + env(safe-area-inset-top)) !important;
        padding-bottom: calc(5rem + env(safe-area-inset-bottom)) !important;
        overflow-x: clip;
        background-attachment: scroll;
    }

    .index,
    .index * {
        box-sizing: border-box;
    }

    .index ::v-deep .van-nav-bar {
        min-height: calc(clamp(3rem, 14vw, 3.5rem) + env(safe-area-inset-top));
    }

    .index ::v-deep .van-nav-bar__content,
    .index ::v-deep .van-nav-bar__left {
        height: clamp(3rem, 14vw, 3.5rem);
    }

    .site-brand {
        max-width: 100%;
        font-size: clamp(1.45rem, 7vw, 2rem);
        line-height: 1.05;
        letter-spacing: -.045em;
        -webkit-text-stroke-width: 1px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .banner.banners {
        width: auto !important;
        height: clamp(7.5rem, 42vw, 10rem) !important;
        margin: .75rem .75rem .65rem !important;
        border-radius: 1.15rem;
    }

    .banner.banners .swiper,
    .banner.banners .swiper-slide,
    .banner.banners a,
    .banner.banners .banner_img {
        display: block;
        width: 100%;
        height: 100%;
    }

    .announcement-section,
    .item {
        width: auto;
        margin: .65rem .75rem;
        padding: .8rem;
        border-radius: 1.15rem;
    }

    .index .announcement-section {
        min-height: 3.25rem;
        padding: .65rem .75rem;
        align-items: center;
    }

    .index .announcement-header {
        width: 2.75rem;
        min-width: 0;
        flex: 0 0 2.75rem;
        margin-right: .55rem;
        white-space: nowrap;
    }

    .index .announcement-header .van-icon {
        width: auto;
        min-width: 0;
        font-size: 1.45rem !important;
    }

    .index .announcement-content,
    .index .announcement-swiper,
    .index .announcement-swiper .swiper-slide {
        min-width: 0;
    }

    .index .announcement-text {
        font-size: .9rem !important;
    }

    .item > .title,
    .item > .title span {
        max-width: 100%;
        line-height: 1.35;
        overflow-wrap: anywhere;
    }

    .item > .title i {
        display: inline-block;
        max-width: 100%;
        padding: .35rem .65rem;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    .hot-announcement-container {
        padding: .55rem 0;
    }

    .hot-item {
        width: clamp(7rem, 38vw, 10rem);
        height: auto;
        aspect-ratio: 3 / 4;
        margin: 0 .35rem;
        border-radius: .85rem;
    }

    .online-badge,
    .profile-online-badge {
        top: .4rem;
        right: .4rem;
        max-width: calc(100% - .8rem);
        padding: .25rem .4rem;
    }

    .online-text,
    .profile-online-badge .online-text {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .tj ul {
        padding: 0;
    }

    .tj ul li {
        display: grid;
        grid-template-columns: clamp(5.5rem, 27vw, 7rem) minmax(0, 1fr);
        align-items: start;
        gap: .7rem;
        margin-bottom: .75rem;
        padding: .75rem;
        border-radius: 1rem;
    }

    .tj .left,
    .tj .right {
        width: 100%;
        min-width: 0;
    }

    .tj .left {
        max-width: none;
    }

    .tj .right {
        margin-left: 0;
    }

    .tj .image-wrapper {
        width: 100%;
        aspect-ratio: 4 / 5;
        overflow: hidden;
        border-radius: .75rem;
    }

    .tj .image-wrapper img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .index .tj .left p {
        width: 100%;
        margin-top: .45rem !important;
        font-size: .9rem !important;
        text-align: center;
        overflow-wrap: anywhere;
    }

    .index .tj .badge-container {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: .4rem;
        margin-bottom: .55rem;
    }

    .index .tj .badge-item {
        min-width: 0;
        justify-content: center;
        padding: .35rem .45rem !important;
        font-size: .78rem !important;
        text-align: center;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    .index .tj .tags-container {
        gap: .35rem;
        margin-bottom: .55rem;
    }

    .index .tj .tag {
        max-width: 100%;
        padding: .32rem .48rem !important;
        font-size: .78rem !important;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    .index .tj .info-container {
        min-width: 0;
        margin: .45rem 0 .55rem;
        padding: .65rem;
    }

    .index .tj .info-container .star-rating {
        flex-wrap: wrap;
        gap: .08rem;
        font-size: .9rem !important;
        overflow-wrap: anywhere;
    }

    .index .tj .info-container .user-details {
        font-size: .82rem !important;
        overflow-wrap: anywhere;
    }

    .index .tj .right .apply-btn {
        min-height: 2.65rem;
        padding: .55rem .7rem;
        font-size: .95rem !important;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    .home-popup-layer {
        align-items: center;
        padding:
            calc(.75rem + env(safe-area-inset-top))
            .75rem
            calc(.75rem + env(safe-area-inset-bottom));
    }

    .home-notice-dialog {
        width: min(100%, 22rem);
        max-width: none;
        max-height: calc(100dvh - 1.5rem - env(safe-area-inset-top) - env(safe-area-inset-bottom));
        margin-top: 0 !important;
        border-radius: 1.25rem;
    }

    .home-popup-head {
        flex: 0 0 auto;
        padding: 1rem 1rem .65rem;
        text-align: center;
        overflow-wrap: anywhere;
    }

    .home-popup-content {
        flex: 1 1 auto;
        min-height: 0;
        max-height: none;
        padding: .5rem 1rem 1rem;
        overscroll-behavior: contain;
    }

    .home-popup-confirm {
        min-height: 3rem;
        height: auto;
        padding: .7rem 1rem;
        white-space: normal;
        overflow-wrap: anywhere;
    }
}

@media (max-width: 350px) {
    .announcement-section,
    .item {
        margin-right: .55rem;
        margin-left: .55rem;
        padding: .65rem;
    }

    .banner.banners {
        margin-right: .55rem !important;
        margin-left: .55rem !important;
    }

    .tj ul li {
        grid-template-columns: 5.25rem minmax(0, 1fr);
        gap: .55rem;
        padding: .6rem;
    }

    .index .tj .badge-container {
        grid-template-columns: minmax(0, 1fr);
    }
}

@supports not (overflow: clip) {
    @media (max-width: 430px) {
        .index {
            overflow-x: hidden;
        }
    }
}
</style>
